import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { PlanningSegment } from "@app/models/rest/planning-segment";
import { PlanningSegmentRestService } from "@app/services/hal/planning-segment-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class PlanningSegmentStore extends RealTimeDataStore<PlanningSegment> {
  constructor() {
    const planningSegmentRestService = inject(PlanningSegmentRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      planningSegmentRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("PlanningSegment");
  }
}
